import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import { UIProps } from "~/types/style";

interface IPlansGrid extends UIProps {
  isAnnual: boolean;
}

export const PlansGrid = styled.div<IPlansGrid>`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: ${getSize(1)};
  width: 100%;

  ${responsive("tablet")} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${getSize(2)};
  }

  ${responsive("desktop")} {
    grid-template-columns: ${({ isAnnual }) =>
      isAnnual ? `repeat(3, 237px)` : `repeat(4, 1fr)`};
  }
`;

export const ToggleContentText = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  color: ${getColor("text")};

  &.selected {
    font-weight: 600;
  }

  ${responsive("tablet")} {
    font-size: 13px;
  }
`;

export const PromotionText = styled.p`
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};
  margin: 0;
  padding: 2px ${getSize(1)};
  border-radius: ${getSize(3)};
  font-size: 11px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0em;
`;

export const SelectText = styled.p`
  color: ${getColor("text")};
  font-weight: 600;
  font-size: 16px;
  margin: 0;
  padding: 0;
`;

export const GreyText = styled.span<IPlansGrid>`
  color: ${getColor("textSecondary")};
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  font-style: italic;
  align-self: flex-start;
  visibility: ${({ isAnnual }) => (isAnnual ? "hidden" : "visible")};
`;

export const PromotionalTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  bottom: 3px;
  font-size: 11px;
`;

export const ArrowIMG = styled.img`
  position: relative;
  right: 17px;
  top: 3px;
  width: 24px;
  height: 8px;
`;